import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8e4d0de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toast-icon" }, null, -1))
const _hoisted_3 = { class: "toast-message-leftalign-close toast-message" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['toast', _ctx.getToastTypeClass(this.toast), 'hide']),
    id: _ctx.toast.id,
    role: "status"
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.headline), 1),
      _createElementVNode("button", {
        class: "toast-close",
        hidden: _ctx.toast.autoDismiss,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeToast()))
      }, null, 8, _hoisted_5),
      _createElementVNode("p", null, _toDisplayString(_ctx.toast.text), 1)
    ])
  ], 10, _hoisted_1))
}